import { render, staticRenderFns } from "./StaffsUploadAdmin.vue?vue&type=template&id=b6df5d8e&scoped=true&"
import script from "./StaffsUploadAdmin.vue?vue&type=script&lang=js&"
export * from "./StaffsUploadAdmin.vue?vue&type=script&lang=js&"
import style0 from "./StaffsUploadAdmin.vue?vue&type=style&index=0&id=b6df5d8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6df5d8e",
  null
  
)

export default component.exports